import React, { Component } from "react";
import Select from "react-select";
import { Field, reduxForm } from 'redux-form'

import { connect } from 'react-redux';
import { InputField } from '../../inputField';

import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { StartOfThisMonthDatePicker, DatePicker } from '../../datePicker';


// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222

export const updateSalesOrder = (salesOrderId, payload, success) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/oversea-warehouse/update-bol-info/${salesOrderId}`,
    data: payload,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      success();
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}


const modalStyle = {
  width: '500px',
  height: '420px',
  marginLeft: '-10%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class InboundDateChangeForm extends Component {

  componentDidMount() {
    const {
      selectedRows: [row],
      change,
    } = this.props;
    change('CustomerBOL', row.CustomerBOLNo);
  }

  handleConfirmClick = (form) => {
    const {
      ESTInboundDate,
      IsaNo,
      Reason,
      Location,
      PickUpDriverName,
      OutboundDriverName,
      ContainerNo,
      CustomerBOL,
    } = form;
    const {
      selectedRows,
      onSuccess,
    } = this.props;

    let inboundDate = ESTInboundDate ? new Date(ESTInboundDate).toISOString() : ''

    const payload = {
      BOLInfo: {
        ESTInboundDate: inboundDate,
        IsaNo,
        Reason,
        Location,
        PickUpDriverName,
        OutboundDriverName,
        ContainerNo,
        CustomerBOL,
      },
    };
    updateSalesOrder(selectedRows[0].SalesOrder_id, payload, onSuccess);
  }

  render() {
    const {
      handleSubmit,
      setModalVisibility,
    } = this.props;
    return (
      <form style={{ width: '100%', padding: '10px' }}>
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="inbound_date" /></label>
          <div className="col-xs-7">
            <Field name="ESTInboundDate" component={StartOfThisMonthDatePicker} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="isa_no" /></label>
          <div className="col-xs-7">
            <Field name="IsaNo" component={InputField} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="reason" /></label>
          <div className="col-xs-7">
            <Field name="Reason" component={InputField} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="location" /></label>
          <div className="col-xs-7">
            <Field name="Location" component={InputField} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="container_no" /></label>
          <div className="col-xs-7">
            <Field name="ContainerNo" component={InputField} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="customer_bol" /></label>
          <div className="col-xs-7">
            <Field name="CustomerBOL" component={InputField} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="pick_up_driver" /></label>
          <div className="col-xs-7">
            <Field name="PickUpDriverName" component={InputField} />
          </div>
        </div>
        <br />
        <div className="form-group" style={{ marginTop: '10px' }}>
          <label className="col-xs-5"><Translate value="outbound_driver" /></label>
          <div className="col-xs-7">
            <Field name="OutboundDriverName" component={InputField} />
          </div>
        </div>
        <br />
        <br />
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '15px' }}>
          <Button
            bsStyle="success"
            className="print-btn"
            type="button"
            onClick={handleSubmit(this.handleConfirmClick)}
          >
            <Translate value="confirm" />
          </Button>
          <span style={{ width: '50px' }} />
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => setModalVisibility()}
          >
            <Translate value="cancel" />
          </Button>
        </div>
      </form>
    )
  }
}

const RDInboundDateChangeForm = reduxForm({
  // a unique name for the form
  form: 'InboundDateChangeForm',
  enableReinitialize: true,
})(InboundDateChangeForm);


const InboundDateChange = ({ setModalVisibility, isVisible, onSuccess, selectedRows }) => (
  <SkyLightStateless
    title={'Sales Order Edit'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <RDInboundDateChangeForm initialValues={selectedRows[0]} selectedRows={selectedRows} onSuccess={onSuccess} setModalVisibility={setModalVisibility} />
  </SkyLightStateless>
)

InboundDateChange.propTypes = propTypes;
InboundDateChange.defaultProps = defaultProps;

export default InboundDateChange;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/InboundDateChange.jsx